module.exports = __webpack_public_path__ + "media/application/images/svgs/instagram-77f42ce4529b6d467871d1d9a4daa009.svg";